function getCurrentUuid() {
  var uuid = $.deparam.querystring()["uuid"];

  if (!uuid) {
    uuid = $.deparam.fragment()["uuid"];
  }

  return uuid;
}

function setCurrentUuid(uuid) {
  if (window.history.replaceState) {
    window.history.replaceState(
      {},
      document.title,
      $.param.querystring(window.location.href, { uuid: uuid })
    );
  } else {
    window.location.replace(
      $.param.fragment(window.location.href, "uuid=" + uuid)
    );
  }
}

function extractId(el) {
  return $(el).attr("id").match(/\d+/g)[0];
}

function getIdFromShort(el) {
  return $(el).closest(".ShortOperation").attr("id").match(/\d+/g)[0];
}

function getOperation(el) {
  return $(el).closest(".SculpteoOperation");
}

function getShortOperation(el) {
  var id;

  if ($(el).hasClass("SculpteoOperation")) {
    id = extractId(el);
  } else {
    id = extractId(getOperation(el));
  }

  if (id == 0) {
    return $(".toolbox-template-" + M_operations.current_operation);
  } else {
    return $("#short-" + id);
  }
}

$.fn.SliderControl = function (o) {
  return this.each(function () {
    if (Object.size(o) == 1 && typeof o["value"] != "undefined") {
      $(".the-slider", this).slider(o);

      return;
    }

    var defaults = {
      orientation: "horizontal",
      precision: 0,
      slide: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          ui.value.toFixed(o.precision)
        );
      },

      change: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          ui.value.toFixed(o.precision)
        );
      },

      stop: function (evt, ui) {
        var param = $(this).closest(".slider-control").data("controlled-param");
        var opts = {};

        opts[param] = ui.value;
        callChangeOperation(opts);
      },

      use_callchangeoperation: true,
      cb: null,
    };
    var options = $.extend(defaults, o);

    if (options.cb) {
      options["stop"] = function (evt, ui) {
        var param = $(this).closest(".slider-control").data("controlled-param");
        var opts = {};

        opts[param] = ui.value;
        options.cb(opts);
      };
    } else if (!options.use_callchangeoperation) {
      options["stop"] = function (evt, ui) {
        var param = $(this).closest(".slider-control").data("controlled-param");
        var opts = {};

        opts[param] = ui.value;
        M_operations.op.modifyOperationAndRefresh(this, opts, o.data);
      };
    }

    if (typeof options["controlled_param"] != "undefined") {
      $(this)
        .closest(".slider-control")
        .data("controlled-param", options["controlled_param"]);
    }

    if (typeof options["reset_value"] != "undefined") {
      $(this)
        .closest(".slider-control")
        .data("reset-value", options["reset_value"]);
    }

    if (typeof options["value"] != "undefined") {
      $(this)
        .closest(".slider-control")
        .data("default-value", options["value"]);
      $(".text-value", $(this).closest(".slider-control")).text(
        options["value"]
      );
    }

    if (typeof options["change_value"] != "undefined") {
      $(".the-slider", this).slider("value", options["change_value"]);
      var param = $(this).closest(".slider-control").data("controlled-param");
      var opts = {};

      opts[param] = options["change_value"];
      callChangeOperation(opts);

      return;
    }

    $(".the-slider", this).slider(options);

    $(".slider-reset", this)
      .unbind("click")
      .click(function (evt) {
        var opts = {};
        var param = $(this).closest(".slider-control").data("controlled-param");

        if (
          typeof $(this).closest(".slider-control").data("reset-value") !=
          "undefined"
        ) {
          opts[param] = $(this).closest(".slider-control").data("reset-value");
        } else {
          opts[param] = $(this)
            .closest(".slider-control")
            .data("default-value");
        }

        callChangeOperation(opts);
        $(".the-slider", $(this).closest(".slider-control")).slider(
          "option",
          "value",
          opts[param]
        );

        return false;
      });
  });
};

$.fn.ColorControl = function (o) {
  /**
   * Control a color parameter of an operation
   * important things are: div with class "color-wheel" inside a div with class "color-control"
   * <div id="BasisColourControl" class="color-control">
   *	 <label class="m8t">{% trans "Background colour" %}:</label>
   *   <div class="color-weel"></div>
   * </div>
   */
  return this.each(function () {
    var defaults = {
      use_callchangeoperation: true,
      color_suffix: "",
      color_feedback: false,
      cb: null,
    };

    if ($(".color-weel", this).length == 0) {
      return;
    }

    var options = $.extend(defaults, o);

    if (typeof options["controlled_param"] != "undefined") {
      $(this)
        .closest(".color-control")
        .data("controlled-param", options["controlled_param"]);
      $(this)
        .closest(".color-control")
        .data("controlled-param-suffix", options["color_suffix"]);
      $(this)
        .closest(".color-control")
        .data("controlled-param-colorfeedback", options["color_feedback"]);
    }
  });
};
